import riot from 'riot'

// import mixins
import CollapseTransition from './collapse-transition'
import CrossSlideInputTransition from './cross-slide-field-transition'
import ExpandTransition from './expand-transition'
import FadeElementTransition from './fade-element-transition'
import GlobalLogger from './global-logger'
import GlobalObservables from './global-observables'
import ModalService from './modal-service'
import NameParser from './name-parser'
import PageScroll from './page-scroll'
import PageTransition from './page-transition'
import PageValidationRunner from './page-validation-runner'
import PhoneTools from './phone-tools'
import PriceTools from './price-tools'
import TextTools from './text-tools'
import validationAnimations from './validation-animations'

// register mixins
riot.mixin('CollapseTransition', CollapseTransition)
riot.mixin('CrossSlideInputTransition', CrossSlideInputTransition)
riot.mixin('ExpandTransition', ExpandTransition)
riot.mixin('FadeElementTransition', FadeElementTransition)
riot.mixin(GlobalLogger)
riot.mixin(GlobalObservables)
riot.mixin('ModalService', ModalService)
riot.mixin('NameParser', NameParser)
riot.mixin('PageScroll', PageScroll)
riot.mixin('PageTransition', PageTransition)
riot.mixin('PageValidationRunner', PageValidationRunner)
riot.mixin('PhoneTools', PhoneTools)
riot.mixin('PriceTools', PriceTools)
riot.mixin('TextTools', TextTools)
riot.mixin('validationAnimations', validationAnimations)